import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheetLoadingContent, Text } from "@src/appV2/redesign/system/ui-components";

interface ExtendedRetryLoadingContentProps {
  action: "clock-in" | "clock-out";
  onCancel: () => void;
  onSkipAction: () => void;
}

export function ExtendedRetryLoadingContent(props: ExtendedRetryLoadingContentProps) {
  const { action, onCancel, onSkipAction } = props;
  const actionText = action === "clock-in" ? "clock in" : "clock out";

  return (
    <Stack>
      <BottomSheetLoadingContent
        title="Still checking..."
        description={
          <Text variant="body1">
            If you correctly used the workplace time clock, you can leave this screen and{" "}
            {actionText} later. We&apos;ll use the time recorded on the workplace time clock.
          </Text>
        }
      />
      <DialogFooter orientation="vertical" sx={{ marginTop: 4 }}>
        <Button fullWidth variant="outlined" size="large" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          fullWidth
          variant="destructive"
          size="large"
          onClick={() => {
            onSkipAction();
          }}
        >
          Skip {actionText}
        </Button>
      </DialogFooter>
    </Stack>
  );
}
